if (!window.colorFamilyActiveStates) {
  window.colorFamilyActiveStates = {};
}

class ColorFamilyTabs extends HTMLElement {
  connectedCallback() {
    console.log('[ColorFamilyTabs] Component connected');

    const form = this.closest('form[data-type="add-to-cart-form"]');
    this.formId = form ? form.id : 'default';
    console.log('[ColorFamilyTabs] Using form ID:', this.formId);

    this.buttons = this.querySelectorAll('.tone-btn');
    this.swatches = this.querySelectorAll('.color-swatch[data-tone]');

    console.log('[ColorFamilyTabs] Found buttons:', this.buttons.length);
    console.log('[ColorFamilyTabs] Found swatches:', this.swatches.length);

    if (this.buttons.length === 0 || this.swatches.length === 0) {
      console.warn('[ColorFamilyTabs] No buttons or swatches found, aborting initialization');
      return;
    }

    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this));
      console.log('[ColorFamilyTabs] Attached click handler to button:', button.dataset.tone);
    });

    if (form) {
      form.addEventListener('variant:change', (event) => {
        console.log('[ColorFamilyTabs] variant:change event received');
        console.log('[ColorFamilyTabs] Event detail:', event.detail);

        setTimeout(() => {
          console.log('[ColorFamilyTabs] Processing after variant:change');
          const activeButton = this.determineActiveTab();
          if (activeButton) {
            console.log('[ColorFamilyTabs] Determined active button:', activeButton.dataset.tone);
            this.activateTab(activeButton);
          } else {
            console.warn('[ColorFamilyTabs] No active button determined');
          }
        }, 10);
      });
    }

    const activeButton = this.determineActiveTab();
    if (activeButton) {
      console.log('[ColorFamilyTabs] Initial active button:', activeButton.dataset.tone);
      this.activateTab(activeButton);
    } else {
      console.warn('[ColorFamilyTabs] No initial active button determined');
    }
  }

  determineActiveTab() {
    console.log('[ColorFamilyTabs] === Determining active tab ===');

    const savedTone = window.colorFamilyActiveStates[this.formId];
    console.log('[ColorFamilyTabs] Saved tone from global state:', savedTone);

    const selectedSwatch = this.querySelector('.color-swatch.is-selected, input:checked + .color-swatch');
    console.log('[ColorFamilyTabs] Selected swatch found:', !!selectedSwatch);

    if (selectedSwatch) {
      const selectedTones = selectedSwatch.dataset.tone ? selectedSwatch.dataset.tone.split(' ') : [];
      console.log('[ColorFamilyTabs] Selected swatch tones:', selectedTones);

      if (selectedTones.length > 0) {
        if (savedTone && selectedTones.includes(savedTone)) {
          console.log('[ColorFamilyTabs] ✓ Saved tone matches selected swatch, using:', savedTone);
          const savedButton = Array.from(this.buttons).find(btn => btn.dataset.tone === savedTone);
          if (savedButton) {
            console.log('[ColorFamilyTabs] ✓ Found button for saved tone');
            return savedButton;
          }
        }

        console.log('[ColorFamilyTabs] Looking for button matching first tone:', selectedTones[0]);
        const matchingButton = Array.from(this.buttons).find(btn =>
          selectedTones.includes(btn.dataset.tone)
        );
        if (matchingButton) {
          console.log('[ColorFamilyTabs] ✓ Found matching button:', matchingButton.dataset.tone);
          return matchingButton;
        }
      }
    }

    const currentlyActiveButton = this.querySelector('.tone-btn.active');
    if (currentlyActiveButton) {
      console.log('[ColorFamilyTabs] ✓ Using currently active button:', currentlyActiveButton.dataset.tone);
      return currentlyActiveButton;
    }

    console.log('[ColorFamilyTabs] ⚠ Using default (first) button');
    return this.buttons[0];
  }

  activateTab(button) {
    if (!button) {
      console.warn('[ColorFamilyTabs] activateTab called with null button');
      return;
    }

    const selectedTone = button.dataset.tone;
    console.log('[ColorFamilyTabs] Activating tab:', selectedTone);

    window.colorFamilyActiveStates[this.formId] = selectedTone;
    console.log('[ColorFamilyTabs] Saved to global state:', selectedTone);

    this.buttons.forEach(btn => {
      const wasActive = btn.classList.contains('active');
      btn.classList.remove('active');
      if (wasActive && btn !== button) {
        console.log('[ColorFamilyTabs] Deactivated button:', btn.dataset.tone);
      }
    });
    button.classList.add('active');
    console.log('[ColorFamilyTabs] Activated button:', selectedTone);

    this.filterSwatches(selectedTone);
  }

  handleTabClick(event) {
    const clickedButton = event.currentTarget;
    console.log('[ColorFamilyTabs] === Tab clicked ===');
    console.log('[ColorFamilyTabs] Clicked tone:', clickedButton.dataset.tone);

    this.activateTab(clickedButton);
  }

  filterSwatches(tone) {
    console.log('[ColorFamilyTabs] Filtering swatches for tone:', tone);

    let visibleCount = 0;
    let hiddenCount = 0;

    this.swatches.forEach(swatch => {
      const swatchTones = swatch.dataset.tone ? swatch.dataset.tone.split(' ') : [];

      if (swatchTones.includes(tone)) {
        swatch.style.display = '';
        visibleCount++;
      } else {
        swatch.style.display = 'none';
        hiddenCount++;
      }
    });

    console.log('[ColorFamilyTabs] Filter result - Visible:', visibleCount, 'Hidden:', hiddenCount);
  }
}

if (!customElements.get('color-family-tabs')) {
  customElements.define('color-family-tabs', ColorFamilyTabs);
  console.log('[ColorFamilyTabs] Custom element registered');
}
